import {
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowLeft,
  ArrowDownRight,
  ArrowUpRight,
  BarChart3,
  Bell,
  Bookmark,
  BookOpen,
  Calendar,
  CalendarCheck,
  CalendarCog,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  ChefHat,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  ClipboardCheck,
  Coffee,
  Copy,
  Crown,
  CreditCard,
  DollarSign,
  Download,
  Droplets,
  Edit,
  Eye,
  FileText,
  Filter,
  Gift,
  Heart,
  History,
  Home,
  Image,
  Info,
  Key,
  Layout,
  LibraryBig,
  LayoutDashboard,
  Loader2,
  List,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Megaphone,
  MessageCircle,
  MessageSquare,
  Minus,
  MoreHorizontal,
  MoreVertical,
  Menu,
  Paperclip,
  Pencil,
  Phone,
  Monitor,
  Play,
  Plus,
  RefreshCw,
  PieChart,
  ServerCrash,
  RotateCcw,
  Save,
  Search,
  Send,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Smile,
  ShoppingCart,
  Square,
  Star,
  Sunrise,
  Sunset,
  TestTube,
  Timer,
  Trash2,
  TrendingDown,
  TrendingUp,
  Upload,
  Utensils,
  User,
  Moon,
  UserRound,
  UserCheck,
  Users,
  Video,
  Wine,
  X,
  XCircle,
  Palmtree,
  BriefcaseBusiness,
  Building2,
  CalendarDays,
  CircleAlert,
  Cpu,
  Layers,
  Sparkles
} from 'lucide-react';

export const iconMap = Object.freeze({
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowLeft,
  ArrowDownRight,
  ArrowUpRight,
  BarChart3,
  Bell,
  Bookmark,
  BookOpen,
  Calendar,
  CalendarCheck,
  CalendarCog,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  ChefHat,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  ClipboardCheck,
  Coffee,
  Copy,
  Crown,
  CreditCard,
  DollarSign,
  Download,
  Droplets,
  Edit,
  Eye,
  FileText,
  Filter,
  Gift,
  Heart,
  History,
  Home,
  Image,
  Info,
  Key,
  Layout,
  LibraryBig,
  LayoutDashboard,
  Loader2,
  List,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Megaphone,
  MessageCircle,
  MessageSquare,
  Minus,
  MoreHorizontal,
  MoreVertical,
  Menu,
  Paperclip,
  Pencil,
  Phone,
  Monitor,
  Play,
  Plus,
  RefreshCw,
  PieChart,
  ServerCrash,
  RotateCcw,
  Save,
  Search,
  Send,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Smile,
  ShoppingCart,
  Square,
  Star,
  Sunrise,
  Sunset,
  TestTube,
  Timer,
  Trash2,
  TrendingDown,
  TrendingUp,
  Upload,
  Utensils,
  User,
  Moon,
  UserRound,
  UserCheck,
  Users,
  Video,
  Wine,
  X,
  XCircle,
  Palmtree,
  PalmTree: Palmtree,
  BriefcaseBusiness,
  Building2,
  CalendarDays,
  CircleAlert,
  Cpu,
  Layers,
  Sparkles
});
